<template>
    <DFormRow
        :label="__('customers.contracts.filters.order_number')"
        is-vertical
        class="mb-0"
    >
        <DAdvancedMultiSelect
            id="order_number"
            add-label-classes="required"
            :options="searchResults"
            :multiple="false"
            :search="true"
            :selection="true"
            :options-empty-placeholder="__('customers.contracts.filters.no_order_found')"
            :search-placeholder="__('customers.contracts.filters.search_order')"
            selection-type="text"
            @update="selectOrder"
            @searchInputChanged="updateOrderOptions"
        />
    </DFormRow>
</template>

<script>

export default {
    props: {
        orderNumbers: {
            type: Array,
            default: () => { return [] }
        },
        customerId: {
            type: Number,
            default: () => { return 0 }
        },
        orderFromFilter: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['selectOrder'],
    data () {
        return {
            searchResults: this.setSelectedOrder(),
            selectedOrder: [],
            searchOrderKey: 0,
            request: null
        }
    },
    computed: {
        id () {
            return 'search-order-input'
        }
    },
    methods: {
        selectOrder (value) {
            this.selectedOrder = [value]

            this.$emit('selectOrder', value)
        },
        setSelectedOrder () {
            const order = this.orderFromFilter ? this.orderFromFilter[0] : null

            return this.orderNumbers.map((item) => {
                return { value: item.value, text: item.text, selected: order === item.value }
            })
        },
        updateOrderOptions (searchTerm) {
            if (this.request) {
                this.request.cancel()
            }

            this.request = window.axios.CancelToken.source()

            window.axios.post(this.$route('customers.customers.orders.search_order', {
                customerId: this.customerId,
                customer: this.customerId,
                osaOrderNo: searchTerm
            }), {}, { cancelToken: this.request.token })
                .then((results) => {
                    this.searchResults = []
                    for (const order of results.data.orderNumbers) {
                        this.searchResults.push({
                            text: order.text,
                            value: order.value
                        })
                    }

                    this.controller = undefined
                })
        }
    }
}
</script>
